import React from "react";
import { useNavigate } from "react-router-dom";

export default function Error() {
  const navigate = useNavigate()
  return (
    <div className="d-flex align-items-center min-vh-100 bg-auth border-top border-top-2 border-primary">
      <div className="container">
        <div className="justify-content-center row">
          <div className="my-5 col-xl-4 col-md-5 col-12">
            <div className="text-center">
              <h6 className="text-uppercase text-muted mb-4">404 error</h6>
              <h1 className="display-4 mb-3">There’s no page here 😭</h1>
              <p className="text-muted mb-4">
                Looks like you ended up here by accident?
              </p>
              <button className="btn btn-primary" onClick={()=>navigate(-1)}>Go Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
